var scrollingElement =
  document.scrollingElement || document.documentElement || document.body;

module.exports = scrollingElement;
